export default {
  /**
   * 指定した年月の日リスト
   * @returns
   */
  days: function ({ year, month }) {
    let days = [];
    if (year === '' || month === '') return days;

    let maxDay = 31;
    switch (parseInt(month)) {
      case (4, 6, 9, 11): // 4月、6月、9月、11月
        maxDay = 30;
        break;
      case 2: // 2月
        // うるう年なら２月２９日はgetMonth()で1（2月）を返すためtrue、それ以外（3月を返す）ならfalse
        maxDay = new Date(year + '/02/29').getMonth() === 1 ? 29 : 28;
        break;
      default: // 1月、3月、5月、7月、8月、10月、12月
        maxDay = 31;
    }

    for (let i = 1; i <= maxDay; i++) {
      days.push(('00' + i).slice(-2));
    }
    return days;
  },
  /**
   * 月リスト
   */
  months: function () {
    return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  },
  /**
   * 未選択時の値
   */
  notSelected: -1,
  /**
   * 支払い方法
   */
  payment: {
    list: [
      {
        payBy: 'A',
        payByName: 'クレジットカード',
        caution: '条件により出来ない場合もございます。',
      },
      {
        payBy: 'B',
        payByName: '事前振り込み',
        caution: '振込手数料はお客様のご負担となります。',
      },
      {
        payBy: 'C',
        payByName: '代引き郵便',
        caution: 'ご購入金額 ¥33,000（税込）以上の場合のみ ¥1,100（税込）発生します。',
      },
      {
        payBy: 'D',
        payByName: '請求',
        caution: null,
      },
    ],
    /**
     * 支払方法名を取得する
     * @param {*} payBy
     * @returns
     */
    getName: function (payBy) {
      let items = this.list.filter((item) => {
        return item.payBy === payBy;
      });
      if (items.length > 0) return items[0].payByName;
      return null;
    },
  },
  /**
   * 予定日用年リスト
   * @returns
   */
  scheduledYears: function () {
    const thisYear = new Date().getFullYear();
    return [(thisYear + 1).toString(), thisYear.toString()];
  },
};
